export const SET_LOADING                  = 'SET_LOADING';
export const SET_PRODUCT                  = 'SET_PRODUCT';
export const SET_EDITED_PRODUCT           = 'SET_EDITED_PRODUCT';
export const SET_CART_TO_ACTIVE_PRODUCT   = 'SET_CART_TO_ACTIVE_PRODUCT';
export const SET_CART_TO_SIMILAR_PRODUCTS = 'SET_CART_TO_SIMILAR_PRODUCTS';
export const SET_SIMILAR_IMAGES           = 'SET_SIMILAR_IMAGES';